import * as React from 'react';

import { Social } from 'common/api/models/Social';

export interface SocialLinksProps {
  social?: Social;
}
export const SocialLinks: React.SFC<SocialLinksProps> = props => {
  if (!props.social) {
    return <span>None</span>;
  }
  return (
    <span style={{ fontSize: '1.2rem' }}>
      {props.social.facebook && (
        <a href={'https://www.facebook.com/' + props.social.facebook} target="_blank" rel="noopener">
          <i className="fa fa-facebook" />
        </a>
      )}{' '}
      {props.social.twitter && (
        <a href={'https://twitter.com/' + props.social.twitter} target="_blank" rel="noopener">
          <i className="fa fa-twitter" />
        </a>
      )}{' '}
      {props.social.instagram && (
        <a href={'https://www.instagram.com/' + props.social.instagram + '/'} target="_blank" rel="noopener">
          <i className="fa fa-instagram" />
        </a>
      )}{' '}
      {props.social.pinterest && (
        <a href={'https://www.pinterest.com/' + props.social.pinterest + '/'} target="_blank" rel="noopener">
          <i className="fa fa-pinterest" />
        </a>
      )}{' '}
      {props.social.snapchat && (
        <a href={'https://www.snapchat.com/add/' + props.social.snapchat} target="_blank" rel="noopener">
          <i className="fa fa-snapchat" />
        </a>
      )}{' '}
      {props.social.houzz && (
        <a href={'https://www.houzz.com/pro/' + props.social.houzz} target="_blank" rel="noopener">
          <i className="fa fa-houzz" />
        </a>
      )}
    </span>
  );
};



// WEBPACK FOOTER //
// ./src/common/components/SocialLinks.tsx